import { getConfiguration } from '@/api/clients/useApiClient.util.ts';
import { UserDetailsWithPermissionDto, UsersApiFactory } from '@/api/generated';
import { sharedAxiosInstance } from '@/api/useAxiosInstance.util.tsx';
import { CONFIG } from '@/config/config.ts';

let currentUserPromise: Promise<UserDetailsWithPermissionDto> | undefined;

export const fetchCurrentUser = (): Promise<UserDetailsWithPermissionDto> => {
  currentUserPromise ??= UsersApiFactory(
    getConfiguration(CONFIG.HOST),
    undefined,
    sharedAxiosInstance,
  )
    .me()
    .then(response => response.data);
  currentUserPromise.catch(() => {
    currentUserPromise = undefined;
  });
  return currentUserPromise;
};

export const resetCurrentUser = (): void => {
  currentUserPromise = undefined;
};
